import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_API_KEY,
  authDomain: import.meta.env.VITE_AUTH_DOMAIN,
  databaseURL: import.meta.env.VITE_DATABASE_URL,
  projectId: import.meta.env.VITE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_APP_ID,
  measurementId: import.meta.env.VITE_MEASUREMENT_ID,
};

const blazeStorageConfig = {
  apiKey: import.meta.env.VITE_BLAZE_STORAGE_API_KEY,
  authDomain: import.meta.env.VITE_BLAZE_STORAGE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_BLAZE_STORAGE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_BLAZE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_BLAZE_STORAGE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_BLAZE_STORAGE_APP_ID,
};

export const app = initializeApp(firebaseConfig);
export const storageApp = initializeApp(blazeStorageConfig, "blaze-storage");

export const db = getFirestore(app);
export const auth = getAuth(storageApp);
export const storage = getStorage(storageApp);
